import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { EnvironmentId } from '@/react/portainer/environments/types';
import PortainerError from '@/portainer/error';
import axios from '@/portainer/services/axios';

import { HelmRelease } from '../types';

import { queryKeys } from './query-keys';
import { GitHelmDryRunPayload } from './gitHelmTypes';

export function useGitHelmDryRun(
  environmentId: EnvironmentId,
  payload: GitHelmDryRunPayload
): UseQueryResult<HelmRelease, PortainerError> {
  return useQuery({
    queryKey: queryKeys.gitInstallDryRun(environmentId, payload),
    queryFn: () => gitHelmDryRun(environmentId, payload),
    enabled:
      !!payload.name &&
      !!payload.namespace &&
      !!payload.repositoryURL &&
      !!payload.helmChartPath,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60, // 1 minute stale time to reduce requests
  });
}

async function gitHelmDryRun(
  environmentId: EnvironmentId,
  payload: GitHelmDryRunPayload
): Promise<HelmRelease> {
  const response = await axios.post(
    `/endpoints/${environmentId}/kubernetes/helm/git/dryrun`,
    payload
  );
  return response.data;
}
